import type {
  AttachmentDocumentRequiredType,
  AttachmentDocumentResponse,
} from '@flex-apis/recruiting';

// TODO: web-pages의 도메인과 중복 제거
export interface AttachmentDocument {
  readonly idHash: string;
  readonly title: string;
  readonly isRequired: boolean;
  readonly type: AttachmentDocumentRequiredType;
  readonly displayOrder: number;
}

export function generateAttachmentDocument(
  res: AttachmentDocumentResponse
): AttachmentDocument {
  if (res.requiredDocumentType === null) {
    throw new Error(
      'generateWithResponse: requiredDocumentType는 null이 될 수 없습니다.'
    );
  }

  return {
    idHash: res.attachmentDocumentIdHash,
    title: res.title,
    isRequired: res.isRequired,
    type: res.requiredDocumentType,
    displayOrder: res.displayOrder,
  };
}
